import React, { ReactNode } from "react";
import styles from "./PeopleSearchHero.module.scss";

type PeopleSearchHeroProps = {
  searchBar?: ReactNode;
  isCompact?: boolean;
};

const PeopleSearchHero = ({ searchBar, isCompact = false }: PeopleSearchHeroProps) => {
  return (
    <section className={`${styles.hero} ${isCompact ? styles.hero_compact : ""}`.trim()}>
      <div
        className={`${styles.collapsible} ${isCompact ? styles.collapsible_hidden : ""}`.trim()}
        aria-hidden={isCompact}
      >
        <div className={styles.intro}>
          <h1 className={styles.title}>Buscá perfiles para tu obra</h1>
          <p className={styles.subtitle}>
            Profesionales, empresas y trabajadores. Buscá por nombre, filtrá por especialidad y ubicación, o describí lo que necesitás con IA.
          </p>
        </div>
      </div>
      {searchBar && <div className={styles.searchBarWrapper}>{searchBar}</div>}
    </section>
  );
};

export default PeopleSearchHero;

